// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1807":"afe46692","4896":"afe46692"}[chunkId] + ".chunk.css";
};